import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "fe-shared/src/components";

interface Props {
  label: string;
  icon: React.ElementType;
  undoLabel?: string;
  undoIcon?: React.ElementType;
  disabled?: boolean;
  className?: string;
  onClick: () => void;
}

const UncheckButton = (props: Props) => {
  const {
    disabled,
    className,
    icon,
    undoIcon = icon,
    label,
    undoLabel = label,
    onClick,
  } = props;
  const { t } = useTranslation();
  const [isUncheckHovered, setIsUncheckHovered] = useState(false);
  const [isUncheckFocused, setIsUncheckFocused] = useState(false);
  const isUncheckActive = isUncheckHovered || isUncheckFocused;

  return (
    <Button
      variant="inline"
      disabled={disabled}
      className={className}
      id="uncheck-action-button"
      onBlur={() => setIsUncheckFocused(false)}
      onFocus={() => setIsUncheckFocused(true)}
      onMouseLeave={() => setIsUncheckHovered(false)}
      onMouseEnter={() => setIsUncheckHovered(true)}
      iconComponent={isUncheckActive ? undoIcon : icon}
      onClick={onClick}
    >
      {t(`transactions.actions.${isUncheckActive ? undoLabel : label}`)}
    </Button>
  );
};

export default UncheckButton;
